var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Speed throughout Journey")]),(_vm.$store.state.points.length > 1)?_c('apexchart',{attrs:{"height":"300","type":"line","options":_vm.options,"series":_vm.series}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }